export enum KpiMaster {
  RED_CARDS = 1011,
  YELLOW_CARDS = 1031,
  X_WIN = 16,
  XG = 111,

  // Match player KPI
  PLAYED_TIME = 72,

  // Attack performance
  RHYTHM = 113,
  COMPLETION_EFFE = 114,
  PRODUCTION = 6,
  ATTACK_SET_PIECES = 10,

  // Defense performance
  INTERRUPTION_TIME = 81,
  AVOIDANCE = 115,
  AVOIDANCE_EFFE = 116,
  DEFENSE_SET_PIECES = 11,
  // Teams Analysis
  // General
  BALL_IN_PLAY_TIME = 47,
  // Attack
  ATTACKING_TIME = 109,
  ATTACK_SHOTS = 49,
  ATTACK_XG = 50,
  ATTACK_DEEP_PROGRESSIONS = 51,
  ATTACK_PASSES_INTO_THE_BOX = 52,
  ATTACK_VAAP = 53,
  ATTACK_EPV = 54,

  // Defense
  DEFENSE_TIME = 55,
  DEFENSE_PRESSURES = 56,
  DEFENSE_PRESSURES_REGAINS = 57,
  DEFENSE_DISTANCE = 58,
  DEFENSE_AGGRESSIVE_ACTIONS = 59,
  DEFENSE_VAAP = 60,
  DEFENSE_EPV = 61,

  // ABP
  ABP_CORNERS = 62,
  ABP_SHOTS_GOALS_FROM_CORNERS = 63,
  ABP_FREE_KICKS = 64,
  ABP_SHOTS_GOALS_FROM_FREE_KICKS = 65,
  ABP_THROW_INS_XG = 66,
  ABP_SHOTS_GOALS_FROM_THROW_INS = 67,
  ABP_PENALTIES = 68,

  // Player Analysis
  PLAYER_ANALYSIS_RATING = 69,
  PLAYER_ANALYSIS_HSR = 75,
  PLAYER_ANALYSIS_RATING_DEFENSE = 71,
  PLAYER_ANALYSIS_RATING_ATTACK = 70,
  PLAYER_ANALYSIS_SPEED = 76,
  PLAYER_ANALYSIS_DISTANCE = 74,
  PLAYER_ANALYSIS_ASSISTS = 78,
  PLAYER_ANALYSIS_GOALS = 77,

  // GOAL KICK

  GOAL_KICK_COMBINATION_ATTACKING = 202,
  GOAL_KICK_DIRECT_PLAY_ATTACKING = 203,

  GOAL_KICK_COMBINATION_DEFENSE = 204,
  GOAL_KICK_DIRECT_PLAY_DEFENSE = 205,

  // BUILD UP
  BUILD_UP_COMBINATION_ATTACKING = 212,
  BUILD_UP_DIRECT_PLAY_ATTACKING = 213,
  BUILD_UP_COMBINATION_DEFENSE = 214,
  BUILD_UP_DIRECT_PLAY_DEFENSE = 215,

  // Positional Play
  POSITIONAL_PLAY_PROGRESSION_INSIDE_ATTACKING = 206,
  POSITIONAL_PLAY_PROGRESSION_FLANKS_ATTACKING = 207,
  POSITIONAL_PLAY_PROGRESSION_TO_SPACE_ATTACKING = 208,
  POSITIONAL_PLAY_PROGRESSION_INSIDE_DEFENSE = 209,
  POSITIONAL_PLAY_PROGRESSION_FLANKS_DEFENSE = 210,
  POSITIONAL_PLAY_PROGRESSION_TO_SPACE_DEFENSE = 211,

  // Finishing
  FINISHING_SHOT_OUTSIDE_BOX_ATTACKING = 216,
  FINISHING_COMBINATION_PLAY_ATTACKING = 217,
  FINISHING_CROSS_ATTACKING = 219,
  FINISHING_INDIVIDUAL_ACTION_ATTACKING = 218,

  FINISHING_SHOT_OUTSIDE_BOX_DEFENSE = 221,
  FINISHING_COMBINATION_PLAY_DEFENSE = 222,
  FINISHING_CROSS_DEFENSE = 224,
  FINISHING_INDIVIDUAL_ACTION_DEFENSE = 223,
  // Player Report

  PLAYER_REPORT_SALARY_SOCCEER_DAILY = -1111111,
  PLAYER_REPORT_SALARY_KYNISCA = -222,
  PLAYER_REPORT_MARKET_VALUE = -3,

  PERFORMANCE_VERY_HIGH = -4,
  PERFORMANCE_HIGH = -5,
  PERFORMANCE_MEDIUM = -6,
  PERFORMANCE_LOW = -7,
  PERFORMANCE_FRIENDLY = -8,

  // Overview
  PLAYED_TIME_SUBTITUTES = -9,
  PLAYED_STARTER_MINUTES = -10,

  // Player Attributes Strengths
  PLAYER_POSITIONING_AWARENESS = -11,
  PLAYER_AERIAL_DOMINANCE = -12,
  PLAYER_COMPOSURE_UNDER_PRESSURE = -13,

  // Player Attributes Weaknesses
  PLAYER_LACK_OF_ACCELERATION = -14,
  PLAYER_LIMITED_PASSING_RANGE = -15,
  PLAYER_DECISION_MAKING_IN_TRANSITION = -16,

  // PERFORMANCE GRAPH
  PERFORMANCE_GENERAL = 2000,
  PERFORMANCE_ATTACK = 2001,
  PERFORMANCE_DEFENSE = 2002, // TOTAL_SPEED TOO
  PHYSICAL_HSR = 2009,
  PHYSICAL_DISTANCE = 2003,
  PHYSICAL_DISTANCE_PER_MIN = 2004, // total_metersperminute_full_all
  PHYSICAL_RUNNING_DISTANCE = 2005, // running_distance_full_all
  PHYSICAL_HI_DISTANCE = 2007, // hi_distance_full_all
  PHYSICAL_HSR_COUNT = 2008, // hsr_count_full_all
  PHYSICAL_SPRINT_COUNT = 2010, // sprint_count_full_all
  PHYSICAL_SPRINT_DISTANCE = 2011, // sprint_distance_full_all
  PHYSICAL_HIGH_ACCEL_COUNT = 2012, // highaccel_count_full_all
  PHYSICAL_HIGH_DECEL_COUNT = 2013, // highdecel_count_full_all
  PHYSICAL_MEDIUM_ACCEL_COUNT = 2014, // medaccel_count_full_all
  PHYSICAL_MEDIUM_DECEL_COUNT = 2015, // meddecel_count_full_all
  PHYSICAL_CHANGE_DIR_COUNT = 2016, // cod_count_full_all

  // Player Roles
  PLAYER_ROLE = 3000,

  // Carrer Section
  GAMES = 1001,
  MINUTES = 1002,
  ATTACKING = 1003,
  DEFENDING = 1004,
  RATING = 1005,

  // Games Section

  GOALS = 1009,
  OWN_GOALS = 1010,
  ASSISTANCES = 1012,
  SHOT_XG = 1013,
  SUCCESSFUL_PASSES = 1014,
  DEFENSIVE_TOUCHES = 1017,
  GROUND_DUELS_WON = 1018,
  GROUND_DUELS_LOST = 1019,
  AERIAL_DUELS_WON = 1020,
  AERIAL_DUELS_LOST = 1021,
  PASSING_ACCURACY = 1039,
  CARDS = 4003,
  DIFFICULTY = -1003,

  // Attack-------
  BALL_RECOVERIES_ATTACK = -6001,
  FOULS_ATTACK = -6002,
  PENALTIES_ATTACK = -6003,
  GROUND_DUELS_ATTACK = -6004,
  AERIAL_DUELS_ATTACK = -6005,
  INTERCEPTED_PASSES_ATTACK = -6006,

  BLOCKED_SHOTS = -6016,
  OFFSIDES_DRAWN = -6017,

  // Defense
  SHORT_PASSES_DEFENSE = -6007,
  LONG_PASSES_DEFENSE = -6008,
  CROSSES_DEFENSE = -6009,
  KEY_PASSES_DEFENSE = -6010,
  LOSSES_DEFENSE = -6011,
  GROUND_DUELS_DEFENSE = -6012,
  DRIBBLES_DEFENSE = -6013,
  FOULS_RECEIVED_DEFENSE = -6014,
  PENALTIES_CONCEDED_DEFENSE = -6015,

  // Player Analysis (game-report player table) — IDs per authoritative backend mapping
  PA_CARDS = 1060,
  PA_RATING = 1061,
  PA_OFFENSIVE_RATING = 1062,
  PA_DEFENSIVE_RATING = 1063,
  PA_POST_SHOT_XG = 1064,
  PA_GOALS_PER_XG = 1065,
  PA_GOALS_PER_POST_SHOT_XG = 1066,
  PA_EXPECTED_ASSISTS = 1067,
  PA_SHOT_ASSISTS = 1068,
  PA_EXPECTED_SHOT_ASSISTS = 1069,
  PA_SHOT_ON_TARGET_PERCENT = 1070,
  PA_SHOTS_PER_GOAL = 1071,
  PA_LONG_RANGE_SHOTS = 1072,
  PA_MID_RANGE_SHOTS = 1073,
  PA_CLOSE_RANGE_SHOTS = 1074,
  PA_ONE_VS_ONE = 1075,
  PA_HEADERS = 1076,
  PA_OPEN_GOAL = 1077,
  PA_PASS_COMPLETION_OVER_EXPECTED = 1081,
  PA_PROGRESSIVE_PASSES = 1082,
  PA_LOW_PASSES = 1083,
  PA_DIAGONAL_PASSES = 1084,
  PA_CHIPPED_PASSES = 1085,
  PA_SHORT_AERIAL_PASSES = 1086,
  PA_LOW_CROSS_PASSES = 1087,
  PA_HIGH_CROSS_PASSES = 1088,
  PA_EXPECTED_PASSES = 1089,
  PA_INTERCEPTIONS = 1090,
  PA_TACKLES = 1091,
  PA_BLOCKS = 1092,
  PA_PRESSING = 1093,
  PA_BALL_WINS = 1008,
  PA_BUILDUP_TO_SPACE_DEFENSE = 226,
  PA_PROGRESSION_LONG_TO_BOX = 227,
  PA_PROGRESSION_LONG_TO_BOX_DEFENSE = 228,
  PA_GROUND_DUELS_PERCENT = 1100,
  PA_AERIAL_DUELS_PERCENT = 1101,
  PA_OFFENSIVE_GROUND_DUELS = 1102,
  PA_DEFENSIVE_GROUND_DUELS = 1103,
  PA_OFFENSIVE_AERIAL_DUELS = 1104,
  PA_DEFENSIVE_AERIAL_DUELS = 1105,
  PA_GK_GOALS_CONCEDED = 1110,
  PA_GK_SHOT_STOPPING = 1111,
  PA_GK_DISTRIBUTION = 1112,
  PA_GK_SWEEPER = 1113,
  PA_GK_HIGH_CLAIMS = 1114,
}

export enum KpiMasterName {
  MINUTES_PLAYED = 'minutes played',
  RED_CARDS = 'red cards',
  YELLOW_CARDS = 'yellow cards',
  X_WIN = 'xwin',
  XG = 'xg',

  RHYTHM = 'rhythm',
  PRODUCTION = 'production',
  COMPLETION_EFFE = 'ompletion effe.',
  ATTACK_SET_PIECES = 'attack set pieces',
  INTERRUPTION_TIME = 'interruption',
  AVOIDANCE = 'avoidance',
  AVOIDANCE_EFFE = 'avoidance effe',
  DEFENSE_SET_PIECES = 'defense set pieces',

  // Defense
  GOALS = 'goals',
  DEFENSE_PERCENT_DEFENSIVE_TIME = 'defense % defensive time',
  DEFENSE_PRESSURES = 'defense pressures',
  DEFENSE_PRESSURES_REGAINS = 'defense pressure regains',
  DEFENSE_DISTANCE = 'defense defensive distance',
  DEFENSE_AGGRESSIVE_ACTIONS = 'defense aggressive actions',
  DEFENSE_VAAP = 'defense vaap',
  DEFENSE_EPV = 'defense epv',

  // Attack
  ATTACKING_TIME = '% attacking time',
  ATTACK_SHOTS = 'attack shots',
  ATTACK_XG = 'attack xg',
  ATTACK_DEEP_PROGRESSIONS = 'attack deep progressions',
  ATTACK_PASSES_INTO_THE_BOX = 'attack passes into the box',
  ATTACK_VAAP = 'attack vaap',
  ATTACK_EPV = 'attack epv',

  // ABP
  ABP_CORNERS = 'abp corners',
  ABP_SHOTS_GOALS_FROM_CORNERS = 'abp shots/goals from corners',
  ABP_FREE_KICKS = 'abp free kicks',
  ABP_SHOTS_GOALS_FROM_FREE_KICKS = 'abp shots/goals free kicks',
  ABP_THROW_INS_XG = 'abp throw ins (throw ins xg)',
  ABP_SHOTS_GOALS_FROM_THROW_INS = 'abp shots/goals from throw ins',
  ABP_PENALTIES = 'abp penalties',

  // Team
  GENERAL_BALL_IN_PLAY_TIME = 'general ball in play time',
}
